import { render, staticRenderFns } from "./BulkUpdateRegion.vue?vue&type=template&id=156c4dfb&scoped=true"
import script from "./BulkUpdateRegion.vue?vue&type=script&lang=js"
export * from "./BulkUpdateRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156c4dfb",
  null
  
)

export default component.exports